import * as $ from 'jquery';
import * as angular from 'angular';

import * as lang from './passport-processing.json';

import {
  Input,
  Inject,
  OnInit,
  Output,
  OnChanges,
  OnDestroy,
  Component,
  EventEmitter,
} from 'ng-metadata/core';

import passportTypeDropHtml from './passport-type-drop.html';
import './passport-type-drop.scss';

/**
 * Passport product type select component (for checkout step 1)
 */
@Component({
  selector: 'gw-passport-type-drop',
  template: passportTypeDropHtml,
})
export class PassportTypeDropComponent implements OnInit, OnChanges, OnDestroy {
  public GW = (<any>window).GW;
  public passportProducts = this.GW.passportProducts;
  public events = 'click.passport.outside touchstart.passport.outside';

  public state = {
    lang,
    open: false,
    preview: null,
    selected: null,
    expanded: false,
  };

  @Input() product;
  @Output() onChange = new EventEmitter();

  constructor(
    @Inject('$scope') private $scope: ng.IScope,
    @Inject('$timeout') private $timeout: ng.ITimeoutService,
  ) {}

  ngOnInit() {
    if (this.product) {
      this.state.selected = this.getProduct(this.product);
    }

    $(document).on(this.events, this.handleClick.bind(this));
  }

  ngOnChanges(changes) {
    if (changes.product) {
      this.state.preview = null;
      this.product = angular.copy(this.product);
      this.state.selected = this.getProduct(this.product);
    }
  }

  ngOnDestroy() {
    $(document).off(this.events, this.handleClick.bind(this));
  }

  handleClick(e: Event) {
    const $target = $(e.target);

    if ($target.closest('.js-passport-type-drop').length === 0) {
      this.$scope.$apply(() => {
        this.closeDrop();
      });
    }
  }

  selectProduct(product) {
    this.state.selected = product;
    this.state.open = false;
    this.onChange.emit({
      productId: product.uuid,
    });
  }

  toggleDrop() {
    if (this.state.open) {
      this.closeDrop();
    } else {
      this.state.open = true;
    }
  }

  closeDrop() {
    this.state.open = false;
    this.state.preview = null;
  }

  openPreview(product) {
    this.state.expanded = true;
    this.state.preview = product;
  }

  closePreview() {
    this.state.expanded = false;
    this.$timeout(() => { this.state.preview = null; }, 300);
  }

  getProduct(productId) {
    return this.passportProducts.find(product => product.uuid === productId);
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/common/passport-type-drop/passport-type-drop.component.ts